import styled from "styled-components";

const GenerationToast = ({ onClick, label = "View", successMessage }) => {
  return (
    <ToastWrapper>
      <Left>
        <IconWrap>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 19 19"
            fill="none"
          >
            <path
              d="M5.41659 9.16634L7.91659 11.6663L12.9166 6.66634M17.4999 9.16634C17.4999 13.7687 13.769 17.4997 9.16659 17.4997C4.56421 17.4997 0.833252 13.7687 0.833252 9.16634C0.833252 4.56397 4.56421 0.833008 9.16659 0.833008C13.769 0.833008 17.4999 4.56397 17.4999 9.16634Z"
              stroke="currentColor"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconWrap>
        <Title>
          {successMessage ? successMessage : "Generation started.."}
        </Title>
      </Left>

      <Action onClick={onClick}>
        {label}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="12"
          viewBox="0 0 7 12"
          fill="none"
        >
          <path
            d="M0.833252 10.833L5.83325 5.83301L0.833252 0.833008"
            stroke="currentColor"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Action>
    </ToastWrapper>
  );
};

export default GenerationToast;

export const ToastWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  padding: 4px 4px 4px 2px;
  width: 100%;
  min-width: 260px;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  flex: 1;
  min-width: 0;
`;

export const IconWrap = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: var(--color-brand-500);
  flex-shrink: 0;
`;

export const Title = styled.div`
  color: var(--color-text-strong, #0f2f54);
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Action = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  background: linear-gradient(
    180deg,
    var(--color-brand-400) 0%,
    var(--color-brand-600) 100%
  );
  border: none;
  box-shadow:
    0 6px 14px rgba(var(--color-brand-600-rgb), 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.5);
  color: #ffffff;
  cursor: pointer;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.01em;
  transition:
    transform 180ms var(--ease-snappy),
    filter 180ms var(--ease-snappy);

  &:hover {
    transform: translateY(-1px);
    filter: brightness(1.08);
  }

  &:active {
    transform: translateY(0) scale(0.98);
  }
`;
